/**
 * Title of a desktop notification for a thread update: the thread's connected operator, else the
 * thread's sender label, else the operator-configured AI agent name (never the demo default).
 */
export function notificationTitle(
  thread: { assignedOperatorName?: string | null; senderName?: string | null } | undefined,
  aiName: string,
): string {
  return thread?.assignedOperatorName ?? thread?.senderName ?? aiName;
}
